import { NativeStackScreenProps } from "@react-navigation/native-stack";

import { StoreProductPage } from "./StoreProductPage";
import { StoreStackNavigatorParamList } from "./StoreStackNavigator";

type Props = NativeStackScreenProps<StoreStackNavigatorParamList, "Packages">;

export const StorePackagesPage = ({ route }: Props) => {
  return (
    <StoreProductPage
      selectedPackageId={route.params?.packageId}
      type="STANDARD"
    />
  );
};
